import { useContext } from 'react'

import { AppContext } from '../../contexts'

import { isEmbedded, isExtension } from '../../helpers/build'

const useWidgetMode = () => {
  const { widgetMode } = useContext(AppContext)

  return widgetMode
}

const useIsEmbedded = () => {
  const mode = useWidgetMode()

  return isEmbedded(mode)
}

const useIsExtension = () => {
  const mode = useWidgetMode()

  return isExtension(mode)
}

// redundant from isExtension? kinda... but may not always be true
const useIsZillow = () => {
  const mode = useWidgetMode()

  return isExtension(mode)
}

export { useWidgetMode, useIsExtension, useIsEmbedded, useIsZillow }
